<template>
  <div
    v-if="clientCurrent && clientCurrent.id"
    class="main-header">
    <div
      :class="{ 'disabled': indexClient === 0 }"
      class="arrow"
      style="left: 10px"
      @click="beforeClient">
      <i class="icon-chevron-left"/>
    </div>
    <div
      class="first-block"
      style="margin-left: 34px;">
      <div class="circle">
        <span>{{ initialName | uppercase }}</span>
      </div>
      <div class="data">
        <p>{{ clientCurrent.firstName }} {{ clientCurrent.lastName }}</p>
        <p>{{ clientCurrent.company }}</p>
      </div>
    </div>
    <div class="second-block">
      <div class="data-2">
        <p>Correo electrónico</p>
        <p>{{ clientCurrent.email }}</p>
      </div>
      <div class="data-2">
        <p>Teléfono</p>
        <p>{{ clientCurrent.phone }}</p>
      </div>
    </div>
    <div
      :class="{ 'disabled': indexClient == (customers.length - 1) }"
      class="arrow"
      style="right: 10px;"
      @click="nextClient">
      <i class="icon-chevron-right"/>
    </div>
  </div>
  <div
    v-else
    class="not-found">
    <h1><i class="icon-info"/></h1>
    <h4>Seleccione un elemento de la lista para visualizar</h4>
  </div>
</template>

<script>
export default {
  name: 'CustomersHeader',
  props: {
    clientCurrent: {
      type: Object,
      default: null
    },
    limitScroll: {
      type: Number,
      default: 0
    }
  },
  computed: {
    initialName () {
      if (this.clientCurrent && this.clientCurrent.firstName) {
        let letter1 = this.clientCurrent.firstName.substr(0, 1)
        let letter2 = this.clientCurrent.lastName.substr(0, 1)
        return letter1 + letter2
      } else {
        return ''
      }
    },
    customers () {
      return this.$store.getters['customers/items']
    },
    indexClient () {
      let index = null
      for (let i = 0; i < this.customers.length; i++) {
        const element = this.customers[i]
        if (element.id === this.clientCurrent.id) {
          index = i
        }
      }
      return index
    }
  },
  methods: {
    nextClient () {
      let nextIndex = this.indexClient
      if (nextIndex < this.customers.length) {
        this.$router.push({ name: 'customers-info', params: { id: this.customers[nextIndex + 1].id } })
      }
    },
    beforeClient () {
      let beforeIndex = this.indexClient
      if (beforeIndex > 0) {
        this.$router.push({ name: 'customers-info', params: { id: this.customers[beforeIndex - 1].id } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .not-found {
    height: 120px;
    background-color: #ffffff;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h1, h4{
      margin: 0;
      i{
        font-size: 40px;
        color: $icon;
      }
    }
  }
  .main-header {
    height: 120px;
    background-color: #ffffff;
    margin-bottom: 20px;
    position: relative;
    display: grid;
    grid-template-columns: 52% 47%;
    border-radius: 3px;
    .first-block {
      height: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #DDDDDD;
      .circle {
        position: relative;
        background-color: #FFBD3A;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        margin-right: 30px;
        span {
          font-family: Roboto;
          font-weight: 300;
          color: #FFFFFF;
          font-size: 28px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .data {
        p {
          margin: 0;
          @include font-primary(16px, regular);
          color: #3E3E3E;
          &:nth-child(2) {
            color: #B5AFAF;
            font-size: 12px;
            margin-top: 2px;
          }
        }
      }
    }
    .second-block {
      height: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      .data-2 {
        p {
          margin: 0;
          font-family: Lato;
          font-weight: 700;
          color: #3E3E3E;
          &:nth-child(2) {
            font-weight: 400;
            color: #707070;
            font-size: 13px;
            margin-top: 3px;
          }
        }
        + div {
          margin-left: 40px;
        }
      }
    }
    .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      font-size: 18px;
      color: #9D9D9D;
      &.disabled {
        color: rgba(#9D9D9D, 0.40);
        cursor: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-header.vue